var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMana20(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-339.15 169.64)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6 0 0 6 6009.1 -169.63)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -895,
    cy: 49.998,
    r: 50,
    fill: "#cac5c0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m658.61 209.96-26.826 89.67h-220.75v-18.408c10.734-12.246 34.5-36.516 71.298-72.786 21.456-21.96 42.912-44.976 64.374-68.988 11.226-12.252 19.428-22.734 24.54-31.44 13.254-18.396 19.896-37.548 19.896-57.468 0-18.396-5.988-34.878-17.988-49.428-12.012-14.568-27.234-21.834-45.6-21.834-39.858 0-71.04 27.072-93.528 81.246l-20.682-7.674c27.072-76.134 69.492-114.2 127.22-114.2 28.626 0 53.016 9.69 73.194 29.124 20.202 19.428 30.282 43.44 30.282 72.036 0 36.306-21.21 71.79-63.625 106.54l-42.912 36.024c-27.6 23.52-50.334 45.222-68.202 65.142-1.5358 1.032-4.0922 4.092-7.6739 9.21h114.98c17.874 0 31.404-3.852 40.608-11.508 7.6739-6.126 15.342-17.88 22.98-35.25h18.408v-7e-3zm-3.06-80.484c0-44.448 9.198-85.584 27.6-123.38 24.012-47.004 56.448-70.524 97.338-70.524 39.33 0 70.758 20.178 94.278 60.54 18.366 32.718 27.564 70.512 27.564 113.42 0 44.97-9.198 85.866-27.564 122.66-24.048 45.954-56.238 68.946-96.588 68.946-38.826 0-70.02-19.644-93.504-59.016-19.428-33.204-29.124-70.752-29.124-112.66zm52.116-20.688c0 38.334 4.0802 72.576 12.258 102.7 12.246 47.04 32.706 70.524 61.314 70.524 46.488 0 69.762-48.282 69.762-144.88 0-119.57-25.302-179.35-75.876-179.35-44.976 0-67.452 46.488-67.452 139.49v11.514z",
    fill: "#0d0f0f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMana20);
export default __webpack_public_path__ + "static/media/mana20.6053bd509f2cb4dc739383bc7d497f90.svg";
export { ForwardRef as ReactComponent };